export default __webpack_public_path__ + "static/media/left.f23f8ab4.svg";